import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ImagePreviewComponent } from 'src/app/app/_component/image-preview/image-preview.component';
import { PopoverButton } from 'src/app/app/_component/popover/popover.model';
import { Animations } from 'src/app/_helpers/animations';
import { globalHelper } from 'src/app/_helpers/global';
import { BookingModel, BookingSpace } from 'src/app/_models/booking.model';
import {
  SpaceAssignmentModel,
  SpaceAssignmentSharedModel,
  SpaceAssignmentWithBookingsModel,
} from 'src/app/_models/space-assignment.model';
import { BookingService } from 'src/app/_services/booking.service';
import { ConfigService } from 'src/app/_services/config.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { SpaceService } from 'src/app/_services/space.service';
import { SpaceType } from 'src/app/_types/space-type';
import { ParkingService } from '../../../parking/parking.service';
import { UserAssignmentViewDetailsComponent } from './user-assignment-view-details/user-assignment-view-details.component';
import { UserAssignmentViewQuickShareComponent } from './user-assignment-view-share-space/user-assignment-view-quick-share.component';
import { UserAssignmentViewShareComponent } from './user-assignment-view-share/user-assignment-view-share.component';

@Component({
  selector: 'app-user-assignment-view',
  templateUrl: './user-assignment-view.component.html',
  styleUrls: [
    './user-assignment-view.component.scss',
    './../../../../_styles/ion-grid-content-table.scss',
  ],
  animations: [
    trigger('toggleHeight', [
      state(
        'inactive',
        style({
          height: '0',
          margin: '0',
          padding: '0',
          opacity: '0',
        })
      ),
      state(
        'active',
        style({
          height: '*',
          margin: '*',
          padding: '*',
          opacity: '1',
        })
      ),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => inactive', animate('300ms ease-out')),
    ]),
    Animations.animeRotate,
  ],
})
export class UserAssignmentViewComponent {
  constructor(
    public alertController: AlertController,
    public translateService: TranslateService,
    public modalCtrl: ModalController,
    public spaceService: SpaceService,
    private loadingCtrl: LoadingController,
    private bookingServ: BookingService,
    private config: ConfigService,
    private parkingServ: ParkingService,
    public popoverController: PopoverController,
    private modalController: ModalController,
    public p: ThisPlatform
  ) {}

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Input()
  customData: string;

  @Input()
  spaceType: SpaceType;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  spaceToSharePost: SpaceAssignmentSharedModel = new SpaceAssignmentSharedModel();
  spaceToSharePut: SpaceAssignmentModel = new SpaceAssignmentModel();
  booking: BookingModel = new BookingModel();
  sharedSpaces: SpaceAssignmentWithBookingsModel[] = [];
  currentLang = this.translateService.currentLang;
  barriers = [];
  showSharedSpaces: boolean = false;
  showBarrierButtonForPastAssignments: boolean = true;
  showLoader = false;
  onLoadingDisable = false;
  barrierButtonText: string = this.translateService.instant('SPACE.BARRIER');
  spaceIsNowShared: boolean = false;
  spaceNameLabel: string;
  // showButtonsLoader: boolean = false;

  showBarierrButtonsAndRegistrationNumber: boolean;

  spacePlug: string;
  permissionSpaceShare: string;

  buttonList: PopoverButton[] = [
    {
      name: 'SPACE.DETAILS',
      icon: 'information-circle',
      eventType: 'info',
    },
    {
      name: 'SPACE.SHARE_SPACE',
      icon: 'arrow-redo',
      eventType: 'share',
    },
  ];

  async ngOnInit() {
    switch (this.spaceType) {
      case SpaceType.Parking:
        this.spacePlug = '../../../assets/icons/parking-plug.svg';
        this.permissionSpaceShare = 'parking.my-reservations.share';
        this.showBarierrButtonsAndRegistrationNumber = true;
        this.spaceNameLabel = this.translateService.instant('SPACE.PLACE');
        break;
      case SpaceType.Desk:
        this.spacePlug = '../../../assets/icons/desk-plug.svg';
        this.permissionSpaceShare = 'desk.my-reservations.share';
        this.showBarierrButtonsAndRegistrationNumber = false;
        this.spaceNameLabel = this.translateService.instant('SPACE.DESK.DESK');
        break;
      case SpaceType.Room:
        this.spacePlug = '../../../assets/icons/room-plug.svg';
        this.showBarierrButtonsAndRegistrationNumber = false;
        this.spaceNameLabel = this.translateService.instant('BOOKING.ROOM');
    }

    this.config.loadConfigs().then((v) => {
      this.barriers = this.config.configs.filter((s) =>
        s.key.includes('parking_barrier')
      );
    });

    if (new Date().getTime() > new Date(this.row.dateTo).getTime()) {
      this.showBarrierButtonForPastAssignments = false;
      this.buttonList.splice(1, 1);
    }
    this.row.sharedAssignments.forEach((share) => {
      this.checkIfSpaceIsShared(share);
    });
  }

  async openBarrier(item: any) {
    if (item.key.includes('exit') && new Date().getHours() < 19) {
      this.shareSpaceWhenLeaving(item);
    } else {
      this.openingDisable();
      this.parkingServ.parkingBarrierOpen(item.key).subscribe(
        () => {},
        async (err) => {
          this.handleError(err);
        }
      );
    }
  }

  exitButtonText(item) {
    if (item.key.includes('exit')) {
      return this.translateService.instant('SPACE.PARKING.OPEN_BARRIER_EXIT');
    } else {
      return this.translateService.instant('SPACE.PARKING.OPEN_BARRIER_ENTER');
    }
  }

  async spaceIsSharedInfo(event: Event) {
    const popover = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      'user-assignment-view-share__popover',
      'SPACE.PARKING.SHARED_RESERVED_BARIERR_WARNING'
    );
  }

  openingDisable() {
    this.onLoadingDisable = true;
    this.barrierButtonText = this.translateService.instant(
      'SPACE.PARKING.OPENING_BARRIER'
    );

    setTimeout(() => {
      this.onLoadingDisable = false;
    }, 5000);
  }

  onToggleSharedSpaces() {
    this.showSharedSpaces = !this.showSharedSpaces;
  }

  checkIfSpaceIsShared(share) {
    if (
      new Date(share.dateFrom).getTime() + 60000 < new Date().getTime() &&
      new Date(share.dateTo).getTime() > new Date().getTime()
    ) {
      this.spaceIsNowShared = true;
    }
  }

  async presentPopover(ev: any) {
    this.bookingServ.booking = this.row;

    let popover = await globalHelper.Popover(
      this.popoverController,
      ev,
      this.buttonList,
      'user-assignment-view-share__popover'
    );
    if (popover) {
      if (popover.data == 'share') {
        this.shareSpace();
      }
      if (popover.data == 'info') {
        this.showInfo();
      }
    }
  }

  async onQRCodePreview($event, qrCode) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { qrCode: qrCode },
      animated: true,
      cssClass: 'image-preview-present',
    });
    modal.present();
  }

  async shareSpace() {
    const modal = await this.modalCtrl.create({
      component: UserAssignmentViewShareComponent,
      animated: true,
      cssClass: 'add-edit-modal',
      componentProps: {
        assignmentDetails: this.row,
        editAssignment: false,
      },
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.spaceToSharePost.idSpaceAssignment = Number(this.row.id);
        this.spaceToSharePost.dateFrom = data.data.dateFrom;
        this.spaceToSharePost.dateTo = data.data.dateTo;

        if (data.data.user) {
          let bookingRoom = new BookingSpace();

          bookingRoom.idSpace = this.row.space.id;

          this.booking.title = 'some title';
          this.booking.startTime = data.data.dateFrom;
          this.booking.endTime = data.data.dateTo;
          this.booking.idUserOwner = data.data.user.id;
          this.booking.bookingSpaces.push(bookingRoom);

          this.bookingServ.booking = this.booking;

          this.addSharedAssignment(true);
        } else {
          this.addSharedAssignment();
        }
      }
    });
  }

  async onEditSharedAssignment(details) {
    const modal = await this.modalCtrl.create({
      component: UserAssignmentViewShareComponent,
      animated: true,
      cssClass: 'add-edit-modal',
      componentProps: {
        assignmentDetails: details,
        editAssignment: true,
        timeOptions: {
          minDate: this.row.dateFrom,
          maxDate: this.row.dateTo,
        },
      },
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.spaceToSharePut.dateFrom = data.data.dateFrom;
        this.spaceToSharePut.dateTo = data.data.dateTo;
        this.editSharedAssignment(details.id);
      }
    });
  }

  async shareSpaceWhenLeaving(item) {
    const modal = await this.modalCtrl.create({
      component: UserAssignmentViewQuickShareComponent,
      animated: true,
      cssClass: 'add-edit-modal',
      componentProps: {
        assignmentDetails: item,
      },
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.role == 'share') {
        if (data.data) {
          this.spaceToSharePost.idSpaceAssignment = Number(this.row.id);
          this.spaceToSharePost.dateFrom = data.data[0];
          this.spaceToSharePost.dateTo = data.data[1];
          this.addSharedAssignment();
        }
        this.openingDisable();
        this.parkingServ.parkingBarrierOpen(item.key).subscribe();
      }
    });
  }

  async showInfo() {
    const modal = await this.modalCtrl.create({
      component: UserAssignmentViewDetailsComponent,
      animated: true,
      cssClass: 'add-edit-modal add-edit-modal--small',
      componentProps: {
        row: this.row,
        type: 'assignment',
      },
    });
    modal.present();
  }
  /**
   * @param shareToSb Argument określający czy miejsce będzie udostępnione konkretnej osobie
   */
  addSharedAssignment(shareToSb: boolean = false) {
    this.spaceService.addAssignmentShared(this.spaceToSharePost).subscribe({
      next: () => {
        if (shareToSb) {
          this.addReservation();
        } else {
          this.actionRequest.emit('assignments');
        }
      },
      error: (err) => {
        this.handleError(err);
      },
    });
  }

  editSharedAssignment(id) {
    this.spaceService.updateAssignment(id, this.spaceToSharePut).subscribe(
      () => {
        this.actionRequest.emit('assignments');
      },
      (err) => {
        this.handleError(err);
      }
    );
  }

  addReservation() {
    this.bookingServ.createBooking().subscribe(() => {
      this.actionRequest.emit('reservations');
    });
  }

  /**
   * Metoda obsługująca bad request
   * @param errorCode Kod błędu. Występuje w (error) =>{error.error.code;}
   */
  async handleError(error) {
    let errorMessage: string = '';
    switch (error.error.code) {
      case 1: {
        errorMessage = this.translateService.instant('SPACE.ERROR.ERROR_1');
        break;
      }
      case 2: {
        errorMessage = this.translateService.instant('SPACE.ERROR.ERROR_2');
        break;
      }
      case 3: {
        errorMessage = this.translateService.instant('SPACE.ERROR.ERROR_3');
        break;
      }
      default: {
        if (error.status === 403) {
          errorMessage = this.translateService.instant(
            'SPACE.ERROR.ERROR_STATUS_403'
          );
        } else {
          errorMessage = this.translateService.instant(
            'SPACE.ERROR.BARRIER_ERROR'
          );
        }
      }
    }
    const alert = await this.alertController.create({
      header: this.translateService.instant('SPACE.ERROR.ERROR'),
      message: errorMessage,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async onDeleteSharedAssignment(space) {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService,
      '',
      space.bookings.length ? 'SPACE.REMOVE_SHARE_WITH_RESERVATIONS_INFO' : null
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant('DELETING'),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.spaceService.deleteAssignment(space.id).subscribe((res) => {
            loadingEl.dismiss();
            this.actionRequest.emit('assignments');
          });
        });
    }
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalCtrl.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: 'image-preview-present',
    });
    modal.present();
  }
}
